export default {"src":"/_next/static/media/building.c5311573.svg","height":25,"width":25};